import { Flex, Form, Typography } from "antd"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../Components/Button"
import InputComponent from "../../../Components/Input"
import TextAreaComponent from "../../../Components/Input/TextArea"
import Icon from "../../../Icon"

const { Text } = Typography

function IntegrationRequestForm({ onClose, onSubmit, loading }) {
  const { t } = useTranslation()

  const [form] = Form.useForm()

  const onFinish = (value) => {
    const data = { ...value }
    onSubmit(data)
  }
  const handleClose = () => {
    clearFormData()
    onClose()
  }

  function clearFormData() {
    form.resetFields()
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
  }

  function onFocusHandler(e) {
    handleClearError(e, e.target.name)
  }

  const addErrorIcon = (error) => (
    <span>
      <Icon type={"alert_triangle_error"} /> {t(error)}
    </span>
  )

  return (
    <Form
      className={"with-default-error"}
      onFinish={onFinish}
      validateTrigger="onSubmit"
      layout="vertical"
      form={form}
      requiredMark={true}
    >
      <Form.Item
        label={t("Integration URL")}
        name="integration_url"
        rules={[{ required: true, message: addErrorIcon("Required fields were not filled.") }]}
        style={{ marginBottom: "16px" }}
      >
        <Form.Item name="integration_url" noStyle>
          <InputComponent
            name="integration_url"
            placeholder={t("Type integration URL you are missing")}
            onFocus={onFocusHandler}
          />
        </Form.Item>
      </Form.Item>

      <Form.Item
        label={
          <Text>
            {t("Description")} <Text type="secondary">({t("optional")})</Text>
          </Text>
        }
        name="description"
      >
        <Form.Item name="description" noStyle>
          <TextAreaComponent
            rows={2}
            name="description"
            placeholder={t("Additional message")}
            autoComplete="dontshow"
            onFocus={onFocusHandler}
          />
        </Form.Item>
      </Form.Item>

      <Flex gap={16} justify="end" style={{ padding: "0 3px 3px 0" }}>
        <ButtonComponent size="large" htmlType="button" onClick={handleClose}>
          {t("Cancel")}
        </ButtonComponent>

        <ButtonComponent
          type="primary"
          size="large"
          htmlType="submit"
          loading={loading}
          className="flex center"
        >
          {t("Send request")}
        </ButtonComponent>
      </Flex>
    </Form>
  )
}

export default IntegrationRequestForm
